export const appConfig = {
    APPLICATION_NAME: "ThisCar",
    DESCRIPTION: "ThisCar",
    // Sanity content revalidation time in seconds (default: 5 minutes)
    // Use shorter times in development (60s) and longer in production (300s)
    SANITY_REVALIDATION_TIME: process.env['NODE_ENV'] === 'development' 
        ? 60 
        : parseInt(process.env['NEXT_PUBLIC_SANITY_REVALIDATION_TIME'] || '300', 10),
    API_REVALIDATION_TIME: 60, //process.env.NEXT_PUBLIC_API_REVALIDATION_TIME,
    AUTOCHECK_CID: process.env['AUTOCHECK_CID'],
    AUTOCHECK_PWD: process.env['AUTOCHECK_PWD'],
    AUTOCHECK_SID: process.env['AUTOCHECK_SID'],
    GOOGLE_SITE_VERIFICATION: process.env['NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION'],
    ANALYTICS_ID: process.env['NEXT_PUBLIC_ANALYTICS_ID'],
    DEALER_ID: process.env['NEXT_PUBLIC_DEALER_ID'],
    CONSUMER_TENANT_ID: process.env['NEXT_PUBLIC_CONSUMER_TENANT_ID'],
    BASE_URL: process.env['NEXT_PUBLIC_BASE_URL'],
    API_URL: process.env['NEXT_PUBLIC_API_URL'],
    HR_EMAIL: process.env['NEXT_PUBLIC_HR_EMAIL'],
    RECAPTCHA_SITE_KEY: process.env['NEXT_PUBLIC_RECAPTCHA_SITE_KEY'],
    GOOGLE_AW_ID: process.env['NEXT_PUBLIC_GOOGLE_AW_ID'],
    GOOGLE_LEAD_CONVERT: process.env['NEXT_PUBLIC_GOOGLE_LEAD_CONVERT'],
    GOOGLE_AD_ID: process.env['NEXT_PUBLIC_GOOGLE_AD_ID'],
    ADMIN_URL: process.env['NEXT_PUBLIC_ADMIN_URL'],
    MIN_CAR_IMAGES: parseInt(process.env['NEXT_PUBLIC_MIN_CAR_IMAGES'] || '9'),
    //Configurations for Sanity Studio
    SANITY_PROJECT_ID: process.env['NEXT_PUBLIC_SANITY_PROJECT_ID'],
    SANITY_DATASET: process.env['NEXT_PUBLIC_SANITY_DATASET'],

    //Google Project
    GOOGLE_PROJECT_ID: process.env['NEXT_PUBLIC_GOOGLE_PROJECT_ID'],

    //Firebase configurations
    FIREBASE_API_KEY: process.env['NEXT_PUBLIC_FIREBASE_API_KEY'],
    FIREBASE_AUTH_DOMAIN: process.env['NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN'],
    FIREBASE_DATABASE_URL: process.env['NEXT_PUBLIC_FIREBASE_DATABASE_URL'],
    FIREBASE_PROJECT_ID: process.env['NEXT_PUBLIC_FIREBASE_PROJECT_ID'],
    FIREBASE_STORAGE_BUCKET: process.env['NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET'],
    FIREBASE_MESSIGING_SENDER_ID: process.env['NEXT_PUBLIC_FIREBASE_MESSIGING_SENDER_ID'],
    FIREBASE_APP_ID: process.env['NEXT_PUBLIC_FIREBASE_APP_ID'],
    FIREBASE_MEASUREMENT_ID: process.env['NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID'],
    FIREBASE_NOTIFICATION_RESPONSE: process.env['NEXT_PUBLIC_SUBMIT_RESPONSE_URL'],

    MAPS_KEY: process.env['NEXT_PUBLIC_MAPS_KEY'],

    experimental: {
        webpackBuildWorker: true
    },

    //BigQuery
    BIG_QUERY_DATASET_ID: process.env['BIG_QUERY_DATASET_ID']
};

export const DefaultBaseImagePath = "/media/";
